import { Specification } from '../models';
import { useDocument } from './useDocument';

export function useSpecification(id: string | 'new' = 'new') {
  return useDocument<Specification>('Specifications', id);
}
